import { css } from '@emotion/core'

export const styles = {
  item: css`
    padding: 6px 0;

    display: flex;
    align-items: flex-start;

    cursor: pointer;
    user-select: none;
  `,

  input: css`
    cursor: pointer;
  `,

  label: css`
    margin-left: 8px;
    font-size: 13px;
    opacity: 0.9;

    > a {
      text-decoration: none;
      color: #3a89c4;

      &:hover {
        text-decoration: underline;
      }
    }
  `,

  labelBold: css`
    color: rgb(21, 21, 21);
    font-weight: 600;
  `,
}
